<template>
  <section
    id="contact-section"
    class="relative min-h-svh w-full select-none overflow-y-clip p-[4vh]"
  >
    <div
      class="flex-center relative h-[92vh] w-full flex-col rounded-lg bg-black uppercase"
    >
      <video
        class="absolute bottom-0 left-0 size-full rounded-lg object-cover object-bottom brightness-[0.5] greyscale"
        :src="contact"
        autoplay
        muted
        loop
        playsinline
      ></video>
      <!-- :style="'background-image: url(' + contact + ') !important; '" -->
      <div class="flex-center z-10 flex-col gap-y-10">
        
        <h1
          id="make-it-happen"
          class="heading-1 max-w-[10ch] text-center leading-none text-[#DC91A6]"
          v-html="makeItHappen"
        ></h1>
        <div
          class="mt-[5%] flex scale-150 items-center lg:scale-[1.5] xl:scale-[2] 2xl:scale-[2.5] 3xl:scale-[3]"
        >
          <Button
            @click="navigateToForm"
            label="Fale conosco"
          />
        </div>
      </div>
      <div
        class="absolute bottom-5 flex w-full items-center justify-center px-5 md:justify-between"
      >
        <div class="hidden md:flex">
          <div class="relative border border-[#DC91A6]">
            <Vue3Lottie
              ref="customControl"
              :animationData="earthLottie"
              :loop="true"
              :autoPlay="true"
            />
          </div>
          <div
            class="flex-center py w-fit flex-col border border-l-0 border-[#DC91A6] font-mono text-[#f6f6f6]"
          >
            <p
              class="flex size-full items-center justify-start border-b border-[#DC91A6] pl-1 pr-2 font-bold"
            >
              Trabalhando 
            </p>
            <p class="flex size-full items-center justify-start pl-1 pr-2">
              com todo o Brasil
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
  import { earthLottie } from '@/assets/videos';
  import { Button } from '../common';
  import { Vue3Lottie } from 'vue3-lottie';
  import { contact } from '@/assets/videos';
  import { onBeforeMount, onMounted, ref } from 'vue';
  import { textSplitterIntoChar } from '@/functions';
  import { animateSplitText } from '@/animations';

  const makeItHappen = ref("Chegou a sua hora");
  onBeforeMount(() => {
    makeItHappen.value = textSplitterIntoChar(makeItHappen.value);
  });
  onMounted(() => {
    animateSplitText(
      '#make-it-happen .letters',
      '#make-it-happen',
      1.5,
      0.01,
      0,
    );
  });
const navigateToForm = () => {
  window.location.href = 'https://form.respondi.app/EzVFfFpn';
};
</script>

<style>
  .lottie-animation-container {
    height: 100% !important;
  }
  .lottie-animation-container svg {
    height: 100px !important;
    width: fit-content !important;
    margin: -10px -30px !important;
    padding: 0 !important;
  }

  .lottie-animation-container {
    --lottie-animation-container-width: fit-content !important;
    --lottie-animation-container-height: 0% !important;
  }
</style>
